import React, { useState } from 'react';
import config from 'src/commons/config-hoc';
import { Badge } from 'antd';
import {
    EditOutlined,
    LogoutOutlined,
    UserOutlined,
    CodepenOutlined,
    NotificationOutlined,
    createFromIconfontCN
} from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { HeaderUser } from 'ra-lib';
import ModifyPassword from './ModifyPassword';
import {locationHref, toLogin} from 'src/commons';

export default config({
    connect: state => ({
        theme: state.layout.theme,
        loginUser: state.layout.loginUser,
    }),
})(function LayoutHeaderUser(props) {
    const { theme, loginUser } = props;

    const [ visible, setVisible ] = useState(false);

    function handleLogout() {
        props.ajax.post('/api/user/logout').finally(() => locationHref('/login'));
    }

    return (
        <div style={{ display: 'flex', alignItems: 'center', marginLeft: 8 }}>
            <HeaderUser
                theme={theme}
                menus={[
                    {
                        text: <><EditOutlined/>修改密码</>,
                        onClick: () => setVisible(true),
                    },
                    {
                        text: <Link to={`/notice/${loginUser?.uid}`}><NotificationOutlined />系统通知</Link>,
                    },
                    {
                        text: <><Link to={`/user/${loginUser?.uid}`}><UserOutlined/>个人中心</Link></>,
                    },
                    // {
                    //     text: <><a href={"http://view.environ.online/Home?uid="+loginUser?.uid+"&appkey="+loginUser.appkey }  target={"_blank"} ><CodepenOutlined/>系统大屏</a></>,
                    // },
                    // {
                    //     text: <><a href={"https://www.environ.online/autoLogin.action?uid="+loginUser?.uid+"&appkey="+loginUser.appkey }  target={"_blank"} ><CodepenOutlined/>运维系统</a></>,
                    // },
                    {
                        text: 'Divider',
                    },
                    {
                        text: <><LogoutOutlined/>退出登录</>,
                        onClick: () => handleLogout(),
                    },
                ]}
                loginUser={loginUser}
            />
            <ModifyPassword
                visible={visible}
                onOk={() => setVisible(false)}
                onCancel={() => setVisible(false)}
            />
        </div>
    );
});
